import * as React from 'react';

import { DropdownField } from '../../../components/dropdownField';

export interface IDemolishedInMoscowProgrammProps {
  value?: boolean;
  onChange(value?: boolean | undefined): void;
}

enum EDemolishedInMoscowProgramm {
  Any,
  Hide,
  Only,
}

const OPTIONS = [
  { value: EDemolishedInMoscowProgramm.Any, label: 'Неважно' },
  { value: EDemolishedInMoscowProgramm.Hide, label: 'Не показывать' },
  { value: EDemolishedInMoscowProgramm.Only, label: 'Только под снос' },
];

export class DemolishedInMoscowProgramm extends React.Component<IDemolishedInMoscowProgrammProps> {
  public render() {
    return <DropdownField value={this.getValue()} onValueChange={this.handleChange} values={OPTIONS} />;
  }

  private handleChange = (value: EDemolishedInMoscowProgramm) => {
    switch (value) {
      case EDemolishedInMoscowProgramm.Hide:
        return this.props.onChange(false);
      case EDemolishedInMoscowProgramm.Only:
        return this.props.onChange(true);
      default:
        return this.props.onChange();
    }
  };

  private getValue = () => {
    switch (this.props.value) {
      case false:
        return EDemolishedInMoscowProgramm.Hide;
      case true:
        return EDemolishedInMoscowProgramm.Only;
      default:
        return EDemolishedInMoscowProgramm.Any;
    }
  };
}
